<template>
  <div @click.stop="void 0" class="chs-label pa-1 ml-5">
    <div class="ma-2 mt-3" style="display: inline-block">
      CUSTOMER IS ON HOLD {{ isCreditHoldCOD ? '(COD)' : '' }}
    </div>
    <v-btn @click="verify" class="verify-btn text-uppercase mx-4 my-1" depressed>
      verify to ship
    </v-btn>
    <verifyToShipForm :sonum="sonum" v-if="sonum" />
  </div>
</template>

<script>
import store from '@/store';
import { mapMutations } from 'vuex';
import verifyToShipForm from '@/components/load_approval/VerifyToShipForm';

export default {
  name: 'CreditHoldStatus',
  computed: {
    verifyToShipObj: {
      get: () => store.state.loadApproval.verifyToShipObj,
      set: v => store.commit('loadApproval/setVerifyToShipObj', v)
    },
    isCreditHoldCOD() {
      return this.customer.creditHoldCOD;
    }
  },
  methods: {
    ...mapMutations('loadApproval', ['setVerifyToShipForm']),
    verify() {
      this.verifyToShipObj.sonum = this.sonum;
      this.setVerifyToShipForm(true);
    }
  },
  props: {
    customer: {
      type: Object,
      required: true
    },
    sonum: {
      type: Number,
      required: true
    }
  },
  components: { verifyToShipForm }
};
</script>

<style scoped>
.chs-label {
  background: yellow;
  border-radius: 2px;
  border: 1px dashed red;
  color: red;
  font-weight: bold;
  float: right;
  margin-top: 5px;

  background-color: yellow;
  -webkit-animation: blink 2500ms infinite;
  animation: blink 2500ms infinite;
}

@-webkit-keyframes blink {
  50% {
    background-color: rgba(245, 132, 80, 0.103);
  }
}
@keyframes blink {
  50% {
    background-color: rgba(245, 132, 80, 0.103);
  }
}

.verify-btn {
  background: rgba(2, 150, 2, 0.89) !important;
  font-weight: bolder;
  color: yellow;
}
</style>
